module.exports = __webpack_public_path__ + "img/product_52.0ef50cd.webp";